import * as types from './mutation_types';
import { EventBus } from '@/event-bus.js';
import Vue from "vue";
const STATUS_INITIAL = 0, STATUS_UPLOADING = 1, STATUS_INGESTING = 2, STATUS_FETCHING = 3, STATUS_SUCCESS = 4, STATUS_FAILED = 5;


export default {

   //User Info
   [types.REQUEST_USER_INFO](state) {
   },
   [types.RECEIVE_USER_INFO_SUCCESS](state, data) {
      state.clientId = data.clientId;
      state.verticalId = data.verticalId;
   },

   //User Profile
   [types.REQUEST_USER_PROFILE](state) {
   },

   [types.RECEIVE_USER_PROFILE_SUCCESS](state, data) {
      state.currentUser = data.info;
   },

   //Templates
   [types.REQUEST_TEMPLATES](state) {

   },
   [types.RECEIVE_TEMPLATES_SUCCESS](state, data) {
      state.templates = data;
   },

   //All Channels
   [types.REQUEST_CHANNELS](state) {
      state.isLoadingChannels = true;
   },

   [types.RECEIVE_CHANNELS_SUCCESS](state, data) {
      state.isLoadingChannels = false;
      for (let c of data) {
         Vue.set(state.channelOptions, c.recid, {isChecked: false, name: c.c_name, recid: c.recid});
      }
   },

   //All Categories
   [types.REQUEST_CATEGORIES](state) {
      state.isLoadingCategories = true;
   },

   [types.RECEIVE_CATEGORIES_SUCCESS](state, data) {
      state.isLoadingCategories = false;
      for (let c of data) {
         Vue.set(state.categoryOptions, c.recid, {isChecked: false, name: c.c_category, recid: c.recid});
      }
   },


   //Media Picker
   [types.OPEN_MEDIA_PICKER](state) {
      state.mediaPickerOpen = true;
   },

   [types.CLOSE_MEDIA_PICKER](state) {
      state.mediaPickerOpen = false;
      state.mpChannelRecid = -1;
      state.mpAssetType = -1;
      state.currSelectedAssetType = -1;
      state.mpActiveId = -1;
      state.mpCurrActiveAssetRecid = -1;
      state.mpMultiSelect = false;

      state.draggingAssetRecid = -1;
      state.selectedAssets = [];
      state.assignedAsset = '';

      state.currSelectedCategory = '';
      state.currSearchTerm = '';
   },

   [types.INIT_DATA](state, {channels, channelRecid, assetType, activeId, currActiveAssetRecid, multiSelect, isScoreboard}) {
      state.mpChannels = channels;
      state.mpChannelRecid = channelRecid;
      state.mpAssetType = assetType;
      state.currSelectedAssetType = assetType instanceof Array ? assetType[0] : assetType;
      state.mpActiveId = activeId;
      state.mpCurrActiveAssetRecid = currActiveAssetRecid;
      state.mpMultiSelect = multiSelect;
      state.isScoreboard = isScoreboard;
   },

   [types.DRAGGING_ASSET](state, assetRecid) {
      state.draggingAssetRecid = assetRecid;
      if (!state.selectedAssets.includes(assetRecid)) {
         state.selectedAssets.push(assetRecid);
      }
   },

   [types.STOP_DRAGGING_ASSET](state) {
      state.draggingAssetRecid = -1;
   },

   [types.ADD_SELECTED_ASSET](state, assetRecid) {
      if (state.selectedAssets.includes(assetRecid)) {
         //remove the asset recid
         state.selectedAssets = state.selectedAssets.filter(function(value){
            return value != assetRecid;
        });
      } else {
         state.selectedAssets.push(assetRecid);
      }
   },

   [types.ASSIGN_ASSET](state, asset) {
      state.assignedAsset = asset;
      state.mpCurrActiveAssetRecid = asset.recid;
      Vue.nextTick(() => {
         state.assignedAsset = null;
      });
   },

   [types.RESET_MEDIA_PICKER](state) {
      state.draggingAssetRecid = -1;
      state.selectedAssets = [];
   },

   

   //Recent
   [types.RESET_RECENT_MEDIA](state) {
      state.mpRecentAssets = [];
      state.recentMore = true;
      state.mpRecentPage = 0;
   },

   [types.REQUEST_RECENT_MEDIA](state) {
      state.isLoadingRecent = true;
   },

   [types.RECEIVE_RECENT_MEDIA_SUCCESS](state, data) {
      state.isLoadingRecent = false;

      //hide 'Load More' if there is no more data to load
      if (data.assets.length < 20) {
         state.recentMore = false;
      } else {
         state.recentMore = true;
      }

      if (state.mpRecentPage > 1) {
         state.mpRecentAssets = state.mpRecentAssets.concat(data.assets);
      } else {
         state.mpRecentAssets = data.assets;
      }
      state.mpRecentPage += 20;
   },


   //Active
   [types.RESET_ACTIVE_MEDIA](state) {
      state.mpActiveAssets = [];
      state.activeMore = true;
      state.mpActivePage = 0;
   },

   [types.REQUEST_ACTIVE_MEDIA](state) {
      state.isLoadingActive = true;
   },

   [types.RECEIVE_ACTIVE_MEDIA_SUCCESS](state, data) {
      state.isLoadingActive = false;

      //hide 'Load More' if there is no more data to load
      if (data.assets.length < 20) {
         state.activeMore = false;
      } else {
         state.activeMore = true;
      }

      if (state.mpActivePage > 1) {
         state.mpActiveAssets = state.mpActiveAssets.concat(data.assets);
      } else {
         state.mpActiveAssets = data.assets;
      }
      state.mpActivePage += 20;
   },


   //MP Selection changes
   [types.CHANGE_CURR_ASSET_TYPE](state, type) {
      state.currSelectedAssetType = type;
   },

   [types.CHANGE_CURR_CATEGORY](state, cat) {
      state.currSelectedCategory = cat;
   },

   [types.CHANGE_CURR_SEARCH](state, searchTerm) {
      state.currSearchTerm = searchTerm;
   },

   //Modal
   [types.DISPLAY_MODAL](state, data) {
      state.modalError = data.modalError;
      state.modalHeaderText = data.modalHeaderText;
      state.modalSubheadText = data.modalSubheadText;
      state.modalMessage = data.modalMessage;
      state.modalList = data.modalList;
      if (data.action) {
         state.actionModal = true;
         if (!data.actionType) {
            console.log('ERROR: action modal must include action type');
         }
         state.modalActionType = data.actionType;
      } else if (data.unsavedChanges) {
         state.unsavedChangesModal = true;
      } else if (data.deleteConfirm) {
         state.deleteConfirmModal = true;
      } else {
         state.notifyModal = true;
      }
   },

   [types.CLOSE_MODAL](state) {
      state.notifyModal = false;
      state.actionModal = false;
      state.unsavedChangesModal = false;
      state.deleteConfirmModal = false;
   },





   /** UPLOAD */
   [types.REQUEST_UPLOAD_MEDIA](state, {validFiles, invalidFiles}) {
      state.currentStatus = STATUS_UPLOADING;
      state.invalidExtFiles = invalidFiles;
      state.toBeUploadedFiles = validFiles;
   },

   [types.NO_VALID_FILES](state) {
      state.currentStatus = STATUS_FAILED;
   },

   [types.RECEIVE_UPLOAD_MEDIA_SUCCESS](state, uploadedFiles) {
      state.uploadedFiles = uploadedFiles;
   },

   [types.REQUEST_INGEST_MEDIA](state) {
      state.currentStatus = STATUS_INGESTING;
   },

   [types.RECEIVE_INGEST_MEDIA_SUCCESS](state, data) {
      state.ingestedRecids = data;
   },

   [types.REQUEST_UPLOADED_FILES](state) {
      state.currentStatus = STATUS_FETCHING;
   },

   [types.RECEIVE_UPLOADED_FILES_SUCCESS](state, files) {
      state.successFiles = files;
      state.currentStatus = STATUS_SUCCESS;
   },

   [types.RESET_UPLOAD](state) {
      state.currentStatus = STATUS_INITIAL;
      state.invalidExtFiles = [];
      state.toBeUploadedFiles = [];
      state.invalidFiles = [];
      state.uploadedFiles = [];
      state.validFiles = [];
      state.successFiles = [];
      state.ingestedRecids = [];
   },



   /* Smart Canvas Overlay */
   [types.OPEN_SMART_CANVAS](state, instanceRecid) {
      state.scOverlayOpen = true;
      state.instanceRecid = instanceRecid;
   },

   [types.CLOSE_SMART_CANVAS](state, instanceRecid) {
      state.scOverlayOpen = false;
      state.instanceRecid = -1;
   },

   [types.OPEN_INSTANCE](state, channelRecid) {
      EventBus.$emit('new-instance-click', state.instanceRecid, state.selectedTemplateRecid, channelRecid);
   },

   [types.USER_LOGOUT](state) {
      //redirecting to login page
      localStorage.setItem('token', '');
      window.location.href = window.location.origin + '/login.html';
   }
}